/* eslint-disable no-unused-vars */
import React from 'react';
import { Router } from '@reach/router';

//import Home from 'containers/Home';
import Lines from 'containers/Lines';
import SiteManager from 'containers/SiteManager';
import AppContainer from 'containers/App';
//<Home path="/current/:idEquip" />
const Routes = (props) => (
  <Router style={{ flex: 1, display: 'flex', overflow: 'auto' }}>
    <SiteManager path="/" />
    
    <AppContainer path="/current/:idEquip" />
    <SiteManager path="/site" />
    <Lines path="/lines" />
  </Router>
);

export default Routes;
